exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".align-category[data-v-3a1ec7a1]{position:relative;top:-30px;left:175px}", ""]);

// exports
